import { ImageField } from '../../components/admin/image-field';

/** Small round profile picture rendered with the kit `ImageField`. */
export const UserPictureField = ({
  source = 'pictureUrl',
}: {
  source?: string;
}) => (
  <ImageField
    source={source}
    className="[&_img]:max-h-[50px] [&_img]:max-w-[50px] [&_img]:rounded-full [&_img]:object-contain"
  />
);
